module.exports = __webpack_public_path__ + "static/img/index-t3.0a1cf76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/index-t3.jpg
// module id = dt0c
// module chunks = 11